import { clearRentContract, getReservationNo, getUserEmail, isGuestAccountActive, Translation as T } from "@awe-web/shared/lib";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../../components/form.js";
import { Col, Row } from "../../../components/grid.js";
import { TypeArea } from "../../../components/layout.js";
import PickupNotice from "../../../components/pickup_notice";
import { SaveTime } from "../../../components/save_time.js";
import { ScreenHeading, ScreenLoading, ScreenSection } from "../../../components/screen.js";
import { MyBmwRentDashboard } from "../../../routing/routes.js";
import { useInitialize } from "../../../util/react.js";
import { initialize } from "./actions.js";

import "./submit_rent_contract_success.scss";

const SCREEN_TITLE = "FSD0000176";
const RESERVATION_NUMBER = "FSD0000177";
const CONFIRMATION_TEXT = "FSD0000178";
const PROFILE_BUTTON = "FSD0000186";

function InternalSubmitRentContractSuccess() {
  const reservationNo = useSelector((state) => getReservationNo(state));
  const email = useSelector((state) => getUserEmail(state));

  return (
    <ScreenSection main dark>
      <TypeArea>
        <Row>
          <Col
            desktop={{ cols: 8, offset: 2 }}
            className="b2c-str-submit-rent-contract-success__reservation-details"
          >
            <ScreenHeading>
              <T code={SCREEN_TITLE} />
            </ScreenHeading>

            <div className="b2c-str-submit-rent-contract-success__reservation-number">
              <div><T code={RESERVATION_NUMBER} /></div>
              <div>{reservationNo}</div>
            </div>

            {email !== undefined && <div>
              <T code={CONFIRMATION_TEXT} data={{ email: <b>{email}</b> }} />
            </div>
            }
          </Col>
        </Row>

        <Row>
          <Col
            desktop={{ cols: 8, offset: 2 }}
            className="b2c-str-submit-rent-contract-success__pickup-notice"
          >
            <PickupNotice reservationPath="B2C" />
          </Col>
        </Row>
      </TypeArea>
    </ScreenSection>
  );
}

export default function B2C_STR_SubmitRentContractSuccess() {
  const dispatch = useDispatch();

  const isGuestAccount = useSelector(state => isGuestAccountActive(state));
  const reservationNo = useSelector((state) => getReservationNo(state));

  const init = useCallback(async () => {
    if (isGuestAccount) {
      const savedState = JSON.parse(sessionStorage.getItem("rentContract"));
      if (savedState) {
        sessionStorage.clear();
        dispatch(clearRentContract(reservationNo));
      }

      return Promise.resolve(true);
    }
    else return await dispatch(initialize());
  }, [dispatch, isGuestAccount, reservationNo]);

  const isReady = useInitialize(init);
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div className="b2c-str-submit-rent-contract-success">
      <InternalSubmitRentContractSuccess />

      <ScreenSection>
        <TypeArea>
          <Row>
            <Col desktop={{ cols: 8, offset: 2 }}>
              <SaveTime />
            </Col>
          </Row>

          <Row>
            <Col tablet={{ cols: 4, offset: 2 }} desktop={{ cols: 4, offset: 4 }}>
              <Button primary continue to={MyBmwRentDashboard.path()}>
                <T code={PROFILE_BUTTON} />
              </Button>
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
